module.exports = __webpack_public_path__ + "static/img/Product_left2.d202973.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/product/Product_left2.png
// module id = /d+8
// module chunks = 1